/* ENGORI — Kennzeichnung KI-gestützter Bilder und Videos
   ---------------------------------------------------------------------------
   Hängt an jedes Bild und jedes Video ein rundes "i" unten rechts. Der Hinweis
   erscheint beim Überfahren mit der Maus und beim Antippen — ohne Tap-Variante
   würden ihn Handynutzer nie zu sehen bekommen.

   Warum per Skript und nicht im Template: Die Medien stecken in Dutzenden
   verschiedener Container (Banner, Galerie, Produktbilder, Kundenfotos,
   Slider). Ein Wrapper je Template wäre an jeder Stelle anders und würde bei
   jedem Theme-Update wieder auseinanderlaufen.
*/
(function () {
  'use strict';

  var TEXT_BILD = 'Dieses Bild entstand durch KI-Unterstützung.';
  var TEXT_VIDEO = 'Dieses Video entstand durch KI-Unterstützung.';
  var MIN_KANTE = 96;      // Icons, Zahlungslogos und Sterne bleiben frei
  var MARKIERT = 'data-eng-ki';
  var BEOBACHTET = 'data-eng-ki-warte'; // Bild wartet auf seine Maße

  // Bilder, die keine Fotos sind
  var AUSGENOMMEN = [
    '.header__heading-logo',      // Shop-Logo
    // Bildblöcke im Footer: Logo und Gütesiegel. Das sind gestaltete Marken-
    // grafiken in derselben Rolle wie das Shop-Logo darüber, keine Produkt-
    // aufnahmen — hier trägt das Zeichen nichts bei und säße zudem in der
    // leeren Ecke des quadratischen Bildkastens, weit weg vom runden Siegel.
    '.footer-block__image-wrapper',
    // Newsletter-Fenster: Das Produktbild darin ist nur Beiwerk zum Rabatt.
    // Dasselbe Foto trägt den Hinweis bereits auf der Produktseite.
    '.eng-np__media',
    // Hero-Banner: statt eines Zeichens je Bild traegt die Section einen
    // einzigen Sammelhinweis (Einstellung ki_hinweis in engori-hero-taschen).
    '.eht',
    // Hover-Buehne der Karten: das Einzelbild darunter traegt das Zeichen bereits.
    '.eng-kb__buehne',
    /* Farbkacheln der Variantenauswahl. Sie werden mit 50 Pixeln dargestellt,
       lägen also unter MIN_KANTE — aber bei lazy geladenen Bildern ist die
       gemessene Breite im ersten Moment 0, und dann greift der Rückfall auf
       naturalWidth. Der liegt bei 150 und damit über der Schwelle, weshalb
       jede Kachel ein Zeichen bekam. Hier grundsätzlich ausgenommen: Das
       Produktfoto daneben trägt den Hinweis ohnehin. */
    '.color-swatch',
    '.color-swatch__image',
    '.payment-badge img',
    '.eng-bnf__icon img',
    '.trustpilot__stars img',
    '.engori-trust-belt-icon img',
    // Vorschaubilder der Produktgalerie: Dasselbe Foto trägt den Hinweis schon
    // im großen Bild daneben. Auf den kleinen Kacheln wäre er nur Unruhe.
    '.thumbnail',
    '.thumbnail-list__item',
    '.thumbnail-slider',
    'svg'
  ].join(',');

  function istVideo(el) {
    return el.tagName === 'VIDEO';
  }

  /* Der Anker fürs Zeichen. In der Produktgalerie ist das `.media` — bei Videos
     liegt dazwischen noch ein <internal-video>, dessen Kasten nicht der ganzen
     Bühne entspricht. `closest` überspringt diese Zwischenschicht; überall
     sonst bleibt es beim direkten Elternelement wie bisher. */
  function traegerVon(el) {
    return el.closest('.media') || el.parentElement;
  }

  function passt(el) {
    if (el.hasAttribute(MARKIERT)) return false;
    if (el.closest(AUSGENOMMEN)) return false;

    // Poster-Bild und Video teilen sich denselben Kasten — sonst zwei Zeichen.
    var traeger = traegerVon(el);
    if (!traeger || traeger.querySelector(':scope > .eng-ki')) return false;

    /* Massgeblich ist, wie gross das Bild DARGESTELLT wird — nicht, wie gross
       die Datei ist. Bei lazy geladenen Bildern liefert getBoundingClientRect
       im ersten Moment 0; der Rueckfall auf naturalWidth misst dann die
       Quelldatei und haengt auch an winzigen Kacheln ein Zeichen an. Deshalb
       zuerst die width/height-Attribute, die die gedachte Anzeigegroesse
       angeben, und erst zuletzt die Dateimasse. */
    var b = el.getBoundingClientRect();
    var attrB = parseInt(el.getAttribute('width'), 10) || 0;
    var attrH = parseInt(el.getAttribute('height'), 10) || 0;
    var breite = b.width || attrB || el.naturalWidth || el.videoWidth || 0;
    var hoehe = b.height || attrH || el.naturalHeight || el.videoHeight || 0;
    return breite >= MIN_KANTE && hoehe >= MIN_KANTE;
  }

  function anhaengen(img) {
    img.setAttribute(MARKIERT, '1');
    /* Sammelhinweis (13.09.2026): Ein unsichtbarer Anker mit
       data-eng-ki-sammel steht fuer mehrere Bilder zugleich, z. B. im
       Hero-Banner. Er bekommt dasselbe Zeichen, der Text kommt aus
       data-eng-ki-text. */
    var TEXT = img.getAttribute('data-eng-ki-text') ||
               (istVideo(img) ? TEXT_VIDEO : TEXT_BILD);

    var traeger = traegerVon(img);
    if (!traeger) return;

    // Das Zeichen braucht einen positionierten Anker, sonst rutscht es weg.
    var stil = window.getComputedStyle(traeger);
    if (stil.position === 'static') traeger.style.position = 'relative';

    /* Ein nacktes <a> um ein Bild ist ein Inline-Element: Seine Box hat keine
       verlässliche Höhe, das absolut positionierte Zeichen landet dann im
       Nichts. Genau so lag das Premium-Siegel im Footer — angehängt, aber
       unsichtbar. inline-block gibt dem Anker die Maße des Bildes, ohne den
       Textfluss zu ändern. */
    if (stil.display === 'inline') traeger.style.display = 'inline-block';

    /* Abstand zur Ecke an die Rundung anpassen. Bei einem Radius R liegt der
       Bogen auf der Diagonalen um rund 0,29·R von der Ecke entfernt — ein
       festes Maß säße bei stark gerundeten Kacheln (Radius 20 bis 40) mitten
       in der Rundung und bei kantigen Bildern unnötig weit innen. Geprüft
       werden Träger und Bild, weil mal der eine, mal das andere gerundet ist. */
    var radius = Math.max(
      parseFloat(stil.borderBottomRightRadius) || 0,
      parseFloat(window.getComputedStyle(img).borderBottomRightRadius) || 0
    );
    var abstand = Math.round(Math.max(6, radius * 0.30 + 4));

    var b = document.createElement('button');
    b.type = 'button';
    // Videos haben in der Galerie stärker gerundete Ecken als Bilder — das
    // Zeichen braucht dort mehr Abstand, sonst sitzt es in der Rundung.
    b.className = istVideo(img) ? 'eng-ki eng-ki--video' : 'eng-ki';
    b.style.setProperty('right', abstand + 'px', 'important');
    b.style.setProperty('bottom', abstand + 'px', 'important');
    b.setAttribute('aria-label', TEXT);
    b.innerHTML = '<span class="eng-ki__i" aria-hidden="true">i</span>' +
                  '<span class="eng-ki__text" role="tooltip">' + TEXT + '</span>';

    // Antippen zeigt den Hinweis, ohne einen darunterliegenden Link auszulösen.
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var offen = b.classList.contains('is-offen');
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
      if (!offen) b.classList.add('is-offen');
    });

    /* 13.09.2026: Die Sprechblase darf hoechstens 60 % der Bildbreite
       einnehmen (Wunsch Werner: sie verdeckte das Produkt grossflaechig). Sie
       haengt am 18-px-Zeichen, eine Prozentangabe in CSS bezoege sich also
       auf 18 px statt aufs Bild. Deshalb misst das Skript die tatsaechliche
       Bildbreite und gibt sie als Variable weiter — beim Anhaengen und bei
       jedem Oeffnen, weil sich die Bildgroesse mit dem Fenster aendert.
       Der Hinweis selbst bleibt unveraendert erhalten (Art. 50 KI-VO). */
    function setzeMax() {
      var w = traeger.getBoundingClientRect().width;
      /* / 1.08: Das geoeffnete Zeichen ist per CSS mit scale(1.08)
         vergroessert, die Sprechblase waechst mit. Ohne den Ausgleich lag sie
         sichtbar bei 61 statt 60 % der Bildbreite (gemessen 13.09.2026). */
      if (w > 0) b.style.setProperty('--eng-ki-max', Math.floor(w * 0.6 / 1.08) + 'px');
    }
    setzeMax();
    b.addEventListener('mouseenter', setzeMax);
    b.addEventListener('focus', setzeMax);
    b.addEventListener('click', setzeMax, true);

    traeger.appendChild(b);
  }

  /* Bilder mit loading="lazy" haben beim ersten Durchlauf weder Maße noch
     Bilddaten und fallen deshalb durch die Größenprüfung. Da Lazy-Loading das
     DOM nicht verändert, greift auch der MutationObserver nicht — das Siegel
     im Footer blieb so bisher ohne Kennzeichnung. Zwei Netze dagegen: ein
     load-Ereignis je Bild und ein IntersectionObserver für Bilder, die schon
     geladen, beim Durchlauf aber noch außerhalb des Sichtfelds waren. */
  var sichtbarkeit = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          sichtbarkeit.unobserve(e.target);
          if (passt(e.target)) anhaengen(e.target);
        });
      }, { rootMargin: '200px' })
    : null;

  function nachzuegler() {
    document.querySelectorAll('img:not([' + MARKIERT + ']):not([' + BEOBACHTET + '])')
      .forEach(function (img) {
        img.setAttribute(BEOBACHTET, '1');
        img.addEventListener('load', function () {
          if (passt(img)) anhaengen(img);
        }, { once: true });
        if (sichtbarkeit) sichtbarkeit.observe(img);
      });
  }

  function durchlauf() {
    // Bewusst in zwei Durchgängen: `querySelectorAll('video, img')` liefert in
    // Dokumentreihenfolge, nicht in Selektorreihenfolge. Liegt in einem Kasten
    // beides (Video plus Posterbild), soll das Zeichen am Video hängen und
    // "Dieses Video …" sagen — deshalb müssen Videos zuerst drankommen.
    document.querySelectorAll('video').forEach(function (el) {
      if (passt(el)) anhaengen(el);
    });
    document.querySelectorAll('img').forEach(function (el) {
      if (passt(el)) anhaengen(el);
    });
    // Sammelanker: ohne Groessenpruefung, ein Zeichen je Traeger.
    document.querySelectorAll('[data-eng-ki-sammel]:not([' + MARKIERT + '])').forEach(function (el) {
      var t = el.parentElement;
      if (t && !t.querySelector(':scope > .eng-ki')) anhaengen(el);
    });
    nachzuegler();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.eng-ki')) {
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.eng-ki.is-offen').forEach(function (x) {
        x.classList.remove('is-offen');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchlauf);
  } else {
    durchlauf();
  }

  // Nachgeladene Bilder (Slider, Varianten-Wechsel, Warenkorb) mitnehmen.
  var warte;
  new MutationObserver(function () {
    clearTimeout(warte);
    warte = setTimeout(durchlauf, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Bilder ohne feste Maße sind beim ersten Durchlauf noch 0 breit.
  window.addEventListener('load', durchlauf);
})();
